const NOTIFICATION_RETURN_STATE_KEY = "notificationReturnState";

const getModalKeysFromSearch = (search = "") => {
  const params = new URLSearchParams(search);
  const modalKeys = params.get("modals");

  if (!modalKeys) return [];

  return modalKeys
    .split(",")
    .map((key) => key.trim())
    .filter(Boolean);
};

export const getModalKeysByStackOrder = (modals = []) =>
  [...modals]
    .filter((modal) => modal?.key)
    .sort((a, b) => (a?.zIndex ?? 0) - (b?.zIndex ?? 0))
    .map((modal) => modal.key);

export const saveNotificationReturnState = ({ companyId, pathname, search, hash = "", modalKeys: modalKeysFromState }) => {
  const modalKeysFromUrl = getModalKeysFromSearch(search);
  const modalKeysFromMemory = Array.isArray(modalKeysFromState) ? modalKeysFromState.filter(Boolean) : [];
  const modalKeys = modalKeysFromMemory.length >= modalKeysFromUrl.length ? modalKeysFromMemory : modalKeysFromUrl;

  if (!companyId) return;

  sessionStorage.setItem(
    NOTIFICATION_RETURN_STATE_KEY,
    JSON.stringify({
      companyId,
      pathname,
      search,
      hash,
      modalKeys,
    }),
  );
};

export const getNotificationReturnState = () => {
  const rawState = sessionStorage.getItem(NOTIFICATION_RETURN_STATE_KEY);
  if (!rawState) return null;

  try {
    const state = JSON.parse(rawState);

    if (!state?.companyId) return null;

    return {
      companyId: state.companyId,
      pathname: state.pathname || "/business",
      search: state.search || "",
      hash: state.hash || "",
      modalKeys: Array.isArray(state.modalKeys) ? state.modalKeys : getModalKeysFromSearch(state.search),
    };
  } catch (error) {
    sessionStorage.removeItem(NOTIFICATION_RETURN_STATE_KEY);
    return null;
  }
};

export const consumeNotificationReturnState = (companyId) => {
  const state = getNotificationReturnState();

  if (!state || String(state.companyId) !== String(companyId)) {
    return null;
  }

  sessionStorage.removeItem(NOTIFICATION_RETURN_STATE_KEY);
  return state;
};
